<template>
  <div class="content-right">
    <!-- <column class="column1" :title="props.title" :ele_have_scrollbar="true" :path="props.path"> -->
    <column
      class="column1"
      :title="props.title"
      :ele_have_scrollbar="true"
      :path="props.path"
    >
      <template #abc>
        <rowBookCardsNew
          v-for="(item, index) in mydata.bookArr"
          :key="index"
          :info="item"
        >
          <template #rowBook>
            <img  :class="item.img_type === 2 ? 'myrotate2': ''"  v-complete:src="item.img_url"/>
            <!-- <img v-complete:src="item.img_url" :class="{ imgIsW: item.imgIsW }" /> -->
          </template>
        </rowBookCardsNew>
      </template>
    </column>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import column from "@/components/column/index.vue";
import rowBookCardsNew from "@/components/rowBookCardsNew/index.vue";
import { bookNew } from "@/api/addedServices/index.js";
// 推荐列表接口
import { getRecommendList } from "@/api/recommend/index.js";
import { useRoute } from "vue-router";
import { dictKeyWord } from "@/utils/dict.js";
const route = useRoute();

const mydata = reactive({
  bookArr: [],
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  path: {
    type: String,
    default: "",
  },
});
////////////////////////////////////////////
//推荐列表
function getRecommendFn() {
  // 使用标题在字典中进行匹配，得到对应的keyword值
  let keyword = dictKeyWord[props.title];
  getRecommendList({
    keyword: keyword,
    page: 1,
    psize: 10,
    column_key: route.path,
  }).then((res) => {
    mydata.bookArr = res.data.list;
    // console.log(mydata.bookArr,"新书上架");
    mydata.bookArr = mydata.bookArr.map((item) => {
      item.img_url = /^http/.test(item.img_url)
        ? item.img_url
        : mydata.VUE_APP_BASE_HOST + item.img_url;
        item.path = item.buy_url_jd || item.buy_url
        item.outPage = true
      // let img = new Image();
      // img.src = item.img_url;
      // item.imgIsW = img.naturalWidth > img.naturalHeight;
      return item;
    });
  });
}

getRecommendFn();

////////////////////////////////////////////
/* 
高一、高二、高三跳转至“图书介绍→高中书系”，
初一、初二、初三跳转至“图书介绍→初中书系”，
一年级、二年级、三年级、四年级、五年级、六年级跳转时“图书介绍→小学书系”。
*/
// function setPath() {
//   if (
//     mydata.userInfo.gradeId === "高一" ||
//     mydata.userInfo.gradeId === "高二" ||
//     mydata.userInfo.gradeId === "高三"
//   ) {
//     mydata.path = "/layout/list/highSchoolBooks";
//     return;
//   }
//   if (
//     mydata.userInfo.gradeId === "初一" ||
//     mydata.userInfo.gradeId === "初二" ||
//     mydata.userInfo.gradeId === "初三"
//   ) {
//     mydata.path = "/layout/list/middleSchoolBooks";
//     return;
//   }
//   if (
//     mydata.userInfo.gradeId === "一年级" ||
//     mydata.userInfo.gradeId === "二年级" ||
//     mydata.userInfo.gradeId === "三年级" ||
//     mydata.userInfo.gradeId === "四年级" ||
//     mydata.userInfo.gradeId === "五年级" ||
//     mydata.userInfo.gradeId === "六年级"
//   ) {
//     mydata.path = "/layout/list/primarySchoolBooks";
//     return;
//   }
// }
// setPath()

// function bookNewFN() {
//   bookNew({gradeId:mydata.userInfo.gradeId}).then((res) => {
//     mydata.bookArr = res.data.list;
//   });
// }
// bookNewFN();
</script>

<style scoped lang="scss">
.content-right {
  // border: 1px solid red;
  width: 320px;
  // 标题
  :deep(.box-column) {
    margin-bottom: 20px;
    .column-title {
      > p {
        display: none;
      }
    }
  }
  // 内容
  .column1 {
    .row-book {
      //  border:1px solid red;
      margin-bottom: 20px;
      img {
        width: 90px;
        height: 120px;
        flex-shrink: 0;
        
        margin-right: 12px;
        // border:1px solid red;
        // margin:10px;
      }
    }
    .row-book:nth-last-of-type(1) {
      margin-bottom: 0px;
    }

    // .row-book:hover{
    //   background-color: #EEEEEE;
    // }
  }
}

:deep(.column-content.ele-have-scrollbar){
  height:400px;
  // border:1px solid red;
}
// .imgIsW {
//   width: 136px !important;
//   height: 105px !important;
// }
</style>
